export const EmailTemplateId = {
  EMAIL_VERIFICATION_REQUEST: 'd-57ae934a04af4e3ebd20a9f6c7abe3bd',
  VERIFICATION_STATUS: 'd-a9a18318381c48e8a782ab8857d88783',
};
export const USER_TYPES = {
  BUYER: 'buyer',
  SELLER: 'seller',
};
export const USD = 'USD';

export const BooleanEnum = Object.freeze({
  TRUE: true,
  FALSE: false,
});

export const OFFER_CONSTANTS = {
  INITIAL: 'initial',
  OFFERED: 'offered',
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  COUNTER: 'counter',
  COUNTER_BY_CUSTOMER: 'counterByCustomer',
  PENDING: 'pending',
  ACCEPT: 'accept',
  ACCEPT_AFTER_COUNTER_OFFER: 'acceptAfterCounterOffer',
  ACCEPT_AFTER_COUNTER_OFFER_BY_PROVIDER: 'acceptAfterCounterOfferByProvider',
  DECLINE_AFTER_COUNTER_OFFER: 'declineAfterCounterOffer',
  DECLINE_AFTER_COUNTER_OFFER_BY_PROVIDER: 'declineAfterCounterOfferByProvider',
};

export const OFFER_STATE_COLORS = {
  OFFERED: '#f77f00',
  ACCEPTED: '#1e4c2f',
  DECLINED: '#59766c',
  EXPIRED: '#ED1B24',
};

export const CUSTOMER = 'customer';
export const PROVIDER = 'provider';
export const LISTING_MIN_PRICE = 0;
export const BASE_CURRENCY = 'USD';
export const BASE_CURRENCY_SYMBOL = '$';
export const OPEN_OFFER_MODAL = '#openOfferModal';

export const MOBILE_MODAL_BREAKPOINT = 768;

export const BOOKING_TYPES = {
  OFFER: 'offer',
  PURCHASE: 'purchase',
};

export const EDIT_LISTING_FIELDS_KEY = {
  SHORT_ITEM_DESCRIPTION: 'short_item_description',
  SIGNERS: 'signers',
  ASSOCIATION: 'association',
  CATEGORY: 'category',
  ITEM_TYPE: 'item_type',
  CONDITION: 'condition',
  ADDITIONAL_ITEM_DESCRIPTION: 'additional_item_description',
  ITEM_SIZE: 'item_size',
  AUTHENTICATION_NONE: 'authentication_none',
  LISTING_TYPE_AUCTION: 'auction',
  LISTING_TYPE_FIXED: 'fixed',
  ACOA: 'acoa',
  BAS: 'bas',
  PSA: 'psa',
  JSA: 'jsa',
  SWAU: 'swau',
  UDA: 'uda',
  Fanatics: 'fanatics',
  Steiner: 'steiner',
  None: 'none',
};

export const TRANSACTION_PROCESS_ALIAS = {
  DEFAULT_PURCHASE: 'default-purchase/release-1',
};

export const MEDIA_UPLOAD_FORMAT = {
  IMAGES: {
    'image/jpeg': [],
    'image/png': [],
  },
  VIDEOS: {
    'video/mp4': [],
    'video/avi': [],
    'video/quicktime': [],
    'video/x-ms-wmv': [],
    'video/x-matroska': [],
    'video/x-flv': [],
    'video/webm': [],
    'video/mpeg': [],
    'video/mov': [],
  },
};

export const ROUTES = {
  LISTINGS: '/listings',
};

export const LISTING_STATES = {
  ALL: 'all',
  PUBLISHED: 'published',
  DRAFT: 'draft',
  UNSELECTED: 'unselected',
};

export const DEFAULT_CONSTANTS = {
  FB_DEFAULT_SHAREING_IMAGE:
    'https://sharetribe.imgix.net/62f0b77f-7563-4e75-a9ba-3b42178359a7/66510c6e-0354-4963-bd6b-bbc9483c994d?auto=format&crop=edges&fit=crop&h=800&w=800&s=81d412540184ce7fae3974a3d3f132e8',
  BASE_CURRENCY_SYMBOL: '$',
};

export const FILTER_COMPONENT_ID = {
  SEARCH_FILTER_MOBILE_ITEM_CATEGORY_PLAIN: 'SearchFiltersMobile.item_type.plain',
  PUB_BUYING_FORMAT: 'buying_format',
  PUB_AUTHENTICATION_TYPE: 'pub_authentication_type',
  PUB_SHOW_ONLY: 'pub_show_only',
};

export const SORT_BY_ENUMS = {
  AUCTION_END: 'auction_end',
  PUB_AUCTION_END: 'pub_auction_end',
};

export const ROUTES_NAME = {
  EDIT_LISTING_PAGE: 'EditListingPage',
  STRIPE_PAYOUT_PAGE: 'StripePayoutPage',
  NEW_LISTING_PAGE: 'NewListingPage',
};

export const phoneNumberCountries = ['US', 'CA', 'GB', 'FR', 'DE', 'NL', 'PL', 'IE', 'CH'];

export const Paths = {
  Tag: '/tag',
};

export const FILTERS_EXCLUDED_FROM_LISTING_CONFIG = ['sellerLocation'];

export const StatusCode = Object.freeze({
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
});

export const InboxPageTabs = Object.freeze({
  SALES: 'sales',
  ORDERS: 'orders',
  OFFERS: 'offers',
  BIDS: 'bids',
  EXPIRED_OFFERS: 'expiredoffers',
});
export const SignupLocationType = Object.freeze({
  INTERNATIONAL: 'international',
  USA: 'united_states',
});

export const PayoutMethod = Object.freeze({
  STRIPE: 'stripe',
});

export const CHECKOUT_STEPS = {
  SHIPPING_DETAILS: 'shippingDetails',
  PAYMENT_DETAILS: 'paymentDetails',
  STRIPE: 'stripe',
  INQUERY: 'inquery',
};

export const NOTIFICATION_TYPES = {
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  PROVIDER_SETUP: 'PROVIDER_SETUP',
  PROFILE_INCOMPLETE: 'PROFILE_INCOMPLETE',
  PAYMENT_METHOD_MISSING: 'PAYMENT_METHOD_MISSING',
};

export const OfferTransitions = Object.freeze({
  //Offers transitions
  SEND_OFFER: 'transition/send-offer',
  ACCEPT_OFFER: 'transition/accept-offer',
  DECLINE_OFFER: 'transition/decline-offer',
  COUNTER_OFFER: 'transition/counter-offer',
  ACCEPT_AFTER_COUNTER_1: 'transition/accept-after-counter-1',
  DECLINE_AFTER_COUNTER_1: 'transition/decline-after-counter-1',
  COUNTER_AFTER_COUNTER_1: 'transition/counter-after-counter-1',
  ACCEPT_AFTER_COUNTER_2: 'transition/accept-after-counter-2',
  DECLINE_AFTER_COUNTER_2: 'transition/decline-after-counter-2',
  COUNTER_AFTER_COUNTER_2: 'transition/counter-after-counter-2',
  ACCEPT_AFTER_COUNTER_3: 'transition/accept-after-counter-3',
  DECLINE_AFTER_COUNTER_3: 'transition/decline-after-counter-3',
  REQUEST_PAYMENT_AFTER_OFFER_ACCEPTED: 'transition/request-payment-after-offer-accepted',
});

export const OFFER_ACCEPTED_TRANSITIONS = Object.freeze([
  OfferTransitions.ACCEPT_OFFER,
  OfferTransitions.ACCEPT_AFTER_COUNTER_1,
  OfferTransitions.ACCEPT_AFTER_COUNTER_2,
  OfferTransitions.ACCEPT_AFTER_COUNTER_3,
]);

export const OfferState = Object.freeze({
  INITIAL: 'initial',
  COUNTER: 'counter',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  ALL: 'all',
});

export const LISTING_TYPES = {
  EQUIPMENT: 'Equipment-Listing',
  SPIRIT: 'Spirit-Listing',
};
